import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import SurveyFormContent from './FormContent'

const SurveyFormView: React.FC = () => {
  return (
    <ViewPageTitle>
      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <SurveyFormContent />
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/survey',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'แบบฟอร์มสำรวจ',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
        ]}>
        แบบฟอร์มสำรวจ
      </PageTitle>

      {children}
    </>
  )
}

export default SurveyFormView
